import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { TranslatedText } from '..';

import { NoMarginBottom } from './DegreeSelect.styles';

import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useUniStudyBranchesOptions } from '@/hooks';
interface DegreeSelectProps {
  objName: string;
}
export const DegreeSelect = ({ objName }: DegreeSelectProps) => {
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  const form = Form.useFormInstance();
  const selectedBranch = Form.useWatch(['userInfo', objName, 'studyBranch'], form);
  const selectedDegree = Form.useWatch(['userInfo', objName, 'degree'], form);
  const { getDegreeOptions } = useUniStudyBranchesOptions();
  const options = getDegreeOptions(selectedBranch, t('OTHER'));
  return (
    <Box flexDirection="column" gap={12}>
      <TranslatedText i18nKey="CAREER_GOAL" />
      <NoMarginBottom $isOther={selectedDegree === 'other'}>
        <Form.Item name={['userInfo', objName, 'degree']} rules={[RULES.REQUIRED]}>
          <Select
            options={options}
            placeholder={t('SELECT_DEGREE')}
            disabled={!selectedBranch}
            onChange={() => {
              form.setFieldValue(['userInfo', objName, 'university'], undefined);
              form.setFieldValue(['userInfo', objName, 'otherUniversity'], undefined);
              form.setFieldValue(['userInfo', objName, 'otherDegree'], undefined);
            }}
          />
        </Form.Item>
      </NoMarginBottom>
      {selectedDegree === 'other' && (
        <Form.Item
          rules={[
            { required: true, message: t('FIELD_REQUIRED') },
            {
              validator: (_, value) => {
                if (selectedDegree === 'other' && !value) {
                  return Promise.reject();
                }
                return Promise.resolve();
              }
            }
          ]}
          name={['userInfo', objName, 'otherDegree']}>
          <Input placeholder={t('OTHER_DEGREE_PLACEHOLDER')} />
        </Form.Item>
      )}
    </Box>
  );
};
